<template>
  <div class="site-contents event-detail d-flex align-items-top flex-wrap">
    <div class="container-fluid custom-container">
      <div class="row" v-if="wishlistDetail.name">
        <div class="col-lg-8 col-md-12 col-sm-12">
          <div class="event-detail">
            <div class="detail-img" @mouseover="imgHover()" @mouseout="imgHoverLeave()">
              <!-- cropped image-->
              <a v-if="cropped" :href="cropped" data-lightbox="image-1">
                <img v-bind:src="cropped" style="height:100%" />
              </a>

              <input
                type="file"
                ref="file"
                accept="image/*"
                style="display: none"
                v-on:change="handleFileUpload()"
              />
              <a
                :href="
                  wishlistDetail.image
                    ? wishlistDetail.image
                    : '../assets/images/detail.png'
                "
                data-lightbox="image-1"
              >
                <img
                  :src="
                    wishlistDetail.image
                      ? wishlistDetail.image
                      : '../assets/images/detail.png'
                  "
                  alt="Wishlist Image"
                />
              </a>
              <a
                :href="
                  wishlistDetail.image
                    ? wishlistDetail.image
                    : '../assets/images/detail.png'
                "
                data-lightbox="image-1"
              >
                <img
                  v-if="wishlistDetail.image"
                  :src="
                    wishlistDetail.image
                      ? wishlistDetail.image
                      : '../assets/images/detail.png'
                  "
                  alt="wishlist Image"
                />
              </a>
            </div>

            <button
              v-show="imageHover == true && isHost && !isExpired"
              @mouseover="imgHover()"
              @mouseout="imgHoverLeave()"
              class="btn btn-primary detail-img-change"
              @click="$refs.file.click()"
            >
              <i class="fa fa-upload"></i>
              Change banner
            </button>
            <div class="card-detail d-flex flex-wrap justify-content-between">
              <template v-if="!editingWishlistName">
                <div
                  class="wishlistTitle"
                  @mouseover="wishlistNameHover = true"
                  @mouseleave="wishlistNameHover = false"
                >
                  <h3>{{ wishlistDetail.name }}</h3>
                  <a
                    class="icon-edit edit"
                    v-if="wishlistNameHover && isHost && !isExpired"
                    @click="editingWishlistName = true"
                  >
                    <i class="fa fa-edit"></i> Edit
                  </a>
                </div>
              </template>
              <template v-else>
                <div class="wishlistTitle">
                  <div class="form-group">
                    <input v-model="wishlistDetail.name" class="form-control" />
                  </div>

                  <a class="icon-save" @click="updateWishlist({ name: wishlistDetail.name })">
                    <i class="fa fa-save"></i>
                    {{ saveText }}
                  </a>
                  <a class="icon-edit" @click="editingWishlistName = false" v-el:close-edit>
                    <i class="fa fa-times"></i> Close
                  </a>
                </div>
              </template>
              <div class="event-info col-12">
                <div class="row justify-content-between no-gutter">
                  <div class="event-date">
                    <p class="date">
                      {{
                      new Date(wishlistDetail.date).toString()
                      | moment("Do MMM YYYY")
                      }}
                    </p>
                    <p v-if="!isExpired" class="days-left">
                      {{
                      new Date(wishlistDetail.date).toString()
                      | moment("from", "now")
                      }}
                    </p>
                    <p v-else>
                      <span v-if="isHost">Your event has expired. Hope you had a good time.</span>
                      <span v-else>This event has expired. Hope you had a great time.</span>
                    </p>
                  </div>

                  <div class="btn-wrap">
                    <!-- {{new Date(wishlistDetail.date)}}
                    {{new Date().toString()}}-->
                    <div v-if="isExpired === false">
                      <a
                        href="#"
                        class="btn btn-default"
                        data-toggle="modal"
                        data-backdrop="static"
                        data-keyboard="false"
                        data-target="#create"
                        @click="openAddGiftModal"
                      >+ Add Gifts</a>
                      <a class="btn btn-facebook" @click="shareToFacebook()">Share</a>
                    </div>

                    <!-- <div class="sort-gift">
                  <p>Sort by</p>
                  <select name="want" class="select-sort" v-model="want" style="float: right">
                    <option value>Desire</option>
                    <option>Date</option>
                    <option>A-Z</option>
                  </select>
                    </div>-->
                  </div>
                </div>
              </div>
              <div class="gift-filter col-12">
                <div class="row justify-content-between no-gutter">
                  <div class="sort-gift">
                    <span>Sort by</span>
                    <div class="select-dropdown">
                      <select name="want" class="select-sort" v-model="want">
                        <option value="Desire">Desire</option>
                        <option value="createdAt">Date</option>
                        <option value="Alphabetically">A-Z</option>
                      </select>
                    </div>
                  </div>
                  <div class="sort-gift">
                    <div class="select-dropdown">
                      <select name="purchased" class="select-sort" v-model="purchased">
                        <!-- <option value>Sort gift</option> -->
                        <option value="On">Show purchased gifts</option>
                        <option value="Off">Show non purchased gifts</option>
                        <option value="All">Show all gifts</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>

              <div class="sidebar sidebar-sm d-lg-none">
                <div id="accordion">
                  <div class="card">
                    <div class="card-header" id="headingOne">
                      <h5
                        class="mb-0 d-flex flex-wrap justify-content-between align-items-center"
                        v-bind:class="{ active: celebrantActive }"
                        @click="clickCelebrant()"
                      >
                        <button
                          class="btn btn-link"
                          data-toggle="collapse"
                          data-target="#collapseOne"
                          aria-expanded="true"
                          aria-controls="collapseOne"
                        >Celebrant Information</button>
                      </h5>
                    </div>

                    <div
                      id="collapseOne"
                      class="collapse show"
                      aria-labelledby="headingOne"
                      data-parent="#accordion"
                    >
                      <div class="card-body">
                        <div class="celeb-info">
                          <span>Celebrant Name</span>
                          <template v-if="!editingCelebrantName">
                            <div
                              class="wishlistTitle"
                              @mouseover="celebrantNameHover = true"
                              @mouseleave="celebrantNameHover = false"
                            >
                              <h4>{{ wishlistDetail.celebrantInformation }}</h4>
                              <a
                                class="icon-edit"
                                v-if="
                                  celebrantNameHover && isHost && !isExpired
                                "
                                @click="editingCelebrantName = true"
                              >
                                <i class="fa fa-edit"></i> Edit
                              </a>
                            </div>
                          </template>
                          <template v-else>
                            <div class="wishlistTitle">
                              <div class="form-group">
                                <input
                                  v-model="wishlistDetail.celebrantInformation"
                                  class="form-control"
                                />
                              </div>
                              <a
                                class="icon-save"
                                @click="
                                  updateWishlist({
                                    celebrantInformation:
                                      wishlistDetail.celebrantInformation,
                                  })
                                "
                              >
                                <i class="fa fa-save"></i> Save
                              </a>
                              <a class="icon-edit" @click="editingCelebrantName = false">
                                <i class="fa fa-times"></i> Close
                              </a>
                            </div>
                          </template>
                          <div
                            class="likes"
                            @mouseover="likesHover = true"
                            @mouseleave="likesHover = false"
                          >
                            <h5>Likes</h5>
                            <!-- <v-chip
                          :key="like.id "
                          v-for="like in wishlistDetail.likes"
                          :label="like.item"
                          :closable="true"
                            ></v-chip>-->
                            <div class="addmore">
                              <div :key="like.id" v-for="like in wishlistDetail.likes">
                                <div index="0" class="chip">
                                  <span class="chip-item">{{ like.item }}</span>
                                  <span
                                    v-if="isHost && !isExpired"
                                    onclick="removeLikes(this)"
                                    class="closebtn"
                                    style="line-height:2"
                                  >×</span>
                                </div>
                              </div>
                              <template v-if="!editingLikes">
                                <a
                                  class="icon-edit"
                                  v-if="likesHover && isHost && !isExpired"
                                  @click="editingLikes = true"
                                >
                                  <i class="fa fa-plus"></i> Add likes
                                </a>
                              </template>
                              <template v-else>
                                <div class="col-md-10">
                                  <div class="form-group">
                                    <input
                                      placeholder="Add Likes"
                                      ref="like"
                                      id="like"
                                      name="like"
                                      data-vv-as="like"
                                      class="form-control"
                                      v-model="like"
                                      v-validate="'min:3|max:50'"
                                      v-bind:class="{
                                        'is-invalid': errors.has('like'),
                                      }"
                                    />
                                    <div class="invalid-feedback">{{ errors.first("like") }}</div>
                                  </div>
                                </div>

                                <button
                                  @click="clickLike()"
                                  type="button"
                                  class="btn btn-primary btn-sm"
                                >Add +</button>
                                <!-- <a
                              class="icon-edit"
                              v-if="likesHover"
                              @click="updateWishlist({likes:'like'})"
                            >
                              <i class="fa fa-save"></i> Save
                                </a>-->
                                <a class="icon-edit" @click="editingLikes = false">
                                  <i class="fa fa-times"></i> Close
                                </a>
                                <!-- <v-chip-input
                            v-if="editingLikes"
                            input-class="form-control"
                            v-model="likes"
                                ></v-chip-input>-->
                              </template>
                            </div>
                          </div>
                          <div
                            class="dislike dis"
                            @mouseover="dislikeHover = true"
                            @mouseleave="dislikeHover = false"
                          >
                            <h5>Dislikes</h5>

                            <!-- <v-chip
                          :key="dislike.id "
                          v-for="dislike in wishlistDetail.dislike"
                          :label="dislike.item"
                          :closable="true"
                            ></v-chip>-->
                            <div class="addmore">
                              <div :key="dislike.id" v-for="dislike in wishlistDetail.dislike">
                                <div index="0" class="chip">
                                  <span class="chip-item">
                                    {{
                                    dislike.item
                                    }}
                                  </span>
                                  <span
                                    v-if="isHost && !isExpired"
                                    onclick="removeDislikes(this)"
                                    class="closebtn"
                                  >×</span>
                                </div>
                              </div>
                              <template v-if="!editingDislike">
                                <a
                                  class="icon-edit"
                                  v-if="dislikeHover && isHost && !isExpired"
                                  @click="editingDislike = true"
                                >
                                  <i class="fa fa-plus"></i> Add dislikes
                                </a>
                              </template>
                              <template v-else>
                                <!-- <v-chip-input
                              ref="dislike"
                              input-class="form-control"
                              v-model="dislike"
                                ></v-chip-input>-->

                                <div class="col-md-10">
                                  <div class="form-group">
                                    <input
                                      placeholder="Add Dislikes"
                                      ref="dislike"
                                      name="dislike"
                                      data-vv-as="dislike"
                                      class="form-control"
                                      v-model="dislike"
                                      v-validate="'min:3|max:50'"
                                      v-bind:class="{
                                        'is-invalid': errors.has('dislike'),
                                      }"
                                    />
                                    <div class="invalid-feedback">{{ errors.first("dislike") }}</div>
                                  </div>
                                </div>

                                <button
                                  type="button"
                                  class="btn btn-primary btn-sm"
                                  @click="clickDislike()"
                                >Add +</button>

                                <!-- <a
                              class="icon-edit"
                              v-if="dislikeHover"
                              @click="updateWishlist({dislike:'dislike'})"
                            >
                              <i class="fa fa-save"></i> Save
                                </a>-->
                                <a class="icon-edit" @click="editingDislike = false">
                                  <i class="fa fa-times"></i> Close
                                </a>

                                <!-- <v-chip-input
                            v-if="editingDislike"
                            input-class="form-control"
                            v-model="dislike"
                                ></v-chip-input>-->
                              </template>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card">
                  <div class="card-header" id="headingTwo">
                    <h5
                      class="mb-0 d-flex flex-wrap justify-content-between align-items-center"
                      v-bind:class="{ active: eventDetailActive }"
                      @click="clickEventDetail()"
                    >
                      <button
                        class="btn btn-link"
                        data-toggle="collapse"
                        data-target="#collapseTwo"
                        aria-expanded="true"
                        aria-controls="collapseTwo"
                      >Event Details</button>
                    </h5>
                  </div>
                  <div
                    id="collapseTwo"
                    class="collapse show"
                    aria-labelledby="headingTwo"
                    data-parent="#accordion"
                  >
                    <div class="card-body">
                      <div class="celeb-info event-details">
                        <span>Description</span>

                        <div class="more-info">
                          <p>
                            <!-- wishlist detail -->
                          </p>
                          <p @mouseover="detailHover = true" @mouseleave="detailHover = false">
                            <template v-if="!editingDetail">
                              {{ wishlistDetail.detail }}
                              <a
                                class="icon-edit"
                                v-if="detailHover && isHost && !isExpired"
                                @click="editingDetail = true"
                              >
                                <i class="fa fa-edit"></i> Edit
                              </a>
                            </template>
                            <template v-else>
                              <div class="form-group">
                                <textarea v-model="wishlistDetail.detail" class="form-control"></textarea>
                              </div>
                              <a
                                class="icon-edit"
                                @click="
                                  updateWishlist({
                                    detail: wishlistDetail.detail,
                                  })
                                "
                              >
                                <i class="fa fa-save"></i>
                                {{ saveText }}
                              </a>
                              <a class="icon-edit" @click="editingDetail = false">
                                <i class="fa fa-times"></i> Close
                              </a>
                            </template>
                          </p>
                          <p>
                            <span>Unique Code</span>
                            <strong>{{ wishlistDetail.uniqueCode }}</strong>
                          </p>
                          <!-- wishlist date -->
                          <p @mouseover="dateHover = true" @mouseleave="dateHover = false">
                            <span>Date</span>

                            <template v-if="!editingDate">
                              <b class="detail-item">
                                {{
                                new Date(wishlistDetail.date).toString()
                                | moment("Do MMM YYYY")
                                }}
                              </b>
                              <a
                                class="icon-edit"
                                v-if="dateHover && isHost && !isExpired"
                                @click="editingDate = true"
                              >
                                <i class="fa fa-edit"></i> Edit
                              </a>
                            </template>
                            <template v-else>
                              <div class="form-group">
                                <datetime
                                  class="theme-red"
                                  input-id="date"
                                  input-class="form-control"
                                  v-model="wishlistDetail.date"
                                  :min-datetime="minDatetime"
                                ></datetime>
                              </div>
                              <a
                                class="icon-edit"
                                @click="
                                  updateWishlist({ date: wishlistDetail.date })
                                "
                              >
                                <i class="fa fa-save"></i> Save
                              </a>
                              <a class="icon-edit" @click="editingDate = false">
                                <i class="fa fa-times"></i> Close
                              </a>
                            </template>
                          </p>
                          <!-- wishlist time -->
                          <p @mouseover="timeHover = true" @mouseleave="timeHover = false">
                            <span>Time</span>
                            <template v-if="!editingTime">
                              {{
                              new Date(time).toString() | moment("hh:mm A")
                              }}
                              <a
                                class="icon-edit"
                                v-if="timeHover && isHost && !isExpired"
                                @click="editingTime = true"
                              >
                                <i class="fa fa-edit"></i> Edit
                              </a>
                            </template>
                            <template v-else>
                              <div class="form-group">
                                <datetime
                                  class="theme-red"
                                  input-class="form-control"
                                  input-id="time"
                                  type="time"
                                  v-model="time"
                                  :min-datetime="minDatetime"
                                  use12-hour
                                ></datetime>
                              </div>
                              <a class="icon-edit" @click="updateWishlist({ time: time })">
                                <i class="fa fa-save"></i> Save
                              </a>
                              <a class="icon-edit" @click="editingTime = false">
                                <i class="fa fa-times"></i> Close
                              </a>
                            </template>
                          </p>
                          <p @mouseover="locationHover = true" @mouseleave="locationHover = false">
                            <span>Location</span>
                            <template v-if="!editingLocation">
                              {{ wishlistDetail.location.address }}
                              <a
                                class="icon-edit"
                                v-if="locationHover && isHost && !isExpired"
                                @click="editingLocation = true"
                              >
                                <i class="fa fa-edit"></i> Edit
                              </a>
                            </template>
                            <template v-else>
                              <div class="form-group">
                                <input
                                  class="form-control"
                                  v-model="wishlistDetail.location.address"
                                />
                              </div>
                              <a
                                class="icon-edit"
                                @click="
                                  updateWishlist({
                                    'location.address':
                                      wishlistDetail.location.address,
                                  })
                                "
                              >
                                <i class="fa fa-save"></i> Save
                              </a>
                              <a class="icon-edit" @click="editingLocation = false">
                                <i class="fa fa-times"></i> Close
                              </a>
                            </template>
                          </p>
                        </div>
                        <div class="guest">
                          <div class="title-view d-flex flex-wrap">
                            <h5 v-if="filteredParticipants.length > 0">Guest List</h5>
                            <a
                              v-if="filteredParticipants.length > 0"
                              href="#"
                              data-toggle="modal"
                              data-target="#guestListModal"
                            >View all</a>
                            <ul class="list-guest">
                              <li
                                :key="participant._id"
                                v-for="(participant,
                                index) in filteredParticipants"
                                class="indv-guest"
                              >
                                <img
                                  v-if="participant.profileImage"
                                  :src="participant.profileImage"
                                  :alt="participant.name"
                                  :title="participant.name"
                                />
                                <img
                                  v-else
                                  src="../../public/assets/images/participant.png"
                                  :alt="participant.name"
                                  :title="participant.name"
                                />
                              </li>

                              <li
                                v-if="extraParticipantsCount != null"
                                class="indv-guest guest-all"
                              >
                                <a
                                  data-toggle="modal"
                                  data-target="#guestListModal"
                                  class="all-view"
                                >+{{ extraParticipantsCount }}</a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <list-gift
                :isExpired="isExpired"
                :celebrantName="celebrantName"
                :want="want"
                :purchased="purchased"
              ></list-gift>
              <add-gift></add-gift>
              <!-- <add-gift :show="showAddGiftModal" @closeAddGiftModal="closeAddGiftModal"></add-gift> -->
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-12 col-sm-12">
          <div class="sidebar">
            <div id="accordion">
              <div class="card">
                <div class="card-header" id="headingOne">
                  <h5
                    class="mb-0 d-flex flex-wrap justify-content-between align-items-center"
                    v-bind:class="{ active: celebrantActive }"
                    @click="clickCelebrant()"
                  >
                    <button
                      class="btn btn-link"
                      data-toggle="collapse"
                      data-target="#collapseOne"
                      aria-expanded="true"
                      aria-controls="collapseOne"
                    >Celebrant Information</button>
                  </h5>
                </div>

                <div
                  id="collapseOne"
                  class="collapse show"
                  aria-labelledby="headingOne"
                  data-parent="#accordion"
                >
                  <div class="card-body">
                    <div class="celeb-info">
                      <span>Celebrant Name</span>
                      <template v-if="!editingCelebrantName">
                        <div
                          class="wishlistTitle"
                          @mouseover="celebrantNameHover = true"
                          @mouseleave="celebrantNameHover = false"
                        >
                          <h4>{{ wishlistDetail.celebrantInformation }}</h4>
                          <a
                            class="icon-edit"
                            v-if="celebrantNameHover && isHost && !isExpired"
                            @click="editingCelebrantName = true"
                          >
                            <i class="fa fa-edit"></i> Edit
                          </a>
                        </div>
                      </template>
                      <template v-else>
                        <div class="wishlistTitle">
                          <div class="form-group">
                            <input
                              v-model="wishlistDetail.celebrantInformation"
                              class="form-control"
                            />
                          </div>
                          <a
                            class="icon-save"
                            @click="
                              updateWishlist({
                                celebrantInformation:
                                  wishlistDetail.celebrantInformation,
                              })
                            "
                          >
                            <i class="fa fa-save"></i> Save
                          </a>
                          <a class="icon-edit" @click="editingCelebrantName = false">
                            <i class="fa fa-times"></i> Close
                          </a>
                        </div>
                      </template>
                      <div
                        class="likes"
                        @mouseover="likesHover = true"
                        @mouseleave="likesHover = false"
                      >
                        <h5>Likes</h5>
                        <!-- <v-chip
                          :key="like.id "
                          v-for="like in wishlistDetail.likes"
                          :label="like.item"
                          :closable="true"
                        ></v-chip>-->
                        <div class="addmore">
                          <div :key="like.id" v-for="like in wishlistDetail.likes">
                            <div index="0" class="chip">
                              <span class="chip-item">{{ like.item }}</span>
                              <span
                                v-if="isHost && !isExpired"
                                onclick="removeLikes(this)"
                                class="closebtn"
                                style="line-height:2"
                              >×</span>
                            </div>
                          </div>
                          <template v-if="!editingLikes">
                            <a
                              class="icon-edit"
                              v-if="likesHover && isHost && !isExpired"
                              @click="editingLikes = true"
                            >
                              <i class="fa fa-plus"></i> Add likes
                            </a>
                          </template>
                          <template v-else>
                            <div class="col-md-10">
                              <div class="form-group">
                                <input
                                  placeholder="Add Likes"
                                  ref="like"
                                  id="like"
                                  name="like"
                                  data-vv-as="like"
                                  class="form-control"
                                  v-model="like"
                                  v-validate="'min:3|max:50'"
                                  v-bind:class="{
                                    'is-invalid': errors.has('like'),
                                  }"
                                />
                                <div class="invalid-feedback">{{ errors.first("like") }}</div>
                              </div>
                            </div>

                            <button
                              @click="clickLike()"
                              type="button"
                              class="btn btn-primary btn-sm"
                            >Add +</button>

                            <!-- <a
                              class="icon-edit"
                              v-if="likesHover"
                              @click="updateWishlist({likes:'like'})"
                            >
                              <i class="fa fa-save"></i> Save
                            </a>-->
                            <a class="icon-edit" @click="editingLikes = false">
                              <i class="fa fa-times"></i> Close
                            </a>
                            <!-- <v-chip-input
                            v-if="editingLikes"
                            input-class="form-control"
                            v-model="likes"
                            ></v-chip-input>-->
                          </template>
                        </div>
                      </div>
                      <div
                        class="dislike dis"
                        @mouseover="dislikeHover = true"
                        @mouseleave="dislikeHover = false"
                      >
                        <h5>Dislikes</h5>

                        <!-- <v-chip
                          :key="dislike.id "
                          v-for="dislike in wishlistDetail.dislike"
                          :label="dislike.item"
                          :closable="true"
                        ></v-chip>-->
                        <div class="addmore">
                          <div :key="dislike.id" v-for="dislike in wishlistDetail.dislike">
                            <div index="0" class="chip">
                              <span class="chip-item">{{ dislike.item }}</span>
                              <span
                                v-if="isHost && !isExpired"
                                onclick="removeDislikes(this)"
                                class="closebtn"
                              >×</span>
                            </div>
                          </div>
                          <template v-if="!editingDislike">
                            <a
                              class="icon-edit"
                              v-if="dislikeHover && isHost && !isExpired"
                              @click="editingDislike = true"
                            >
                              <i class="fa fa-plus"></i> Add dislikes
                            </a>
                          </template>
                          <template v-else>
                            <!-- <v-chip-input
                              ref="dislike"
                              input-class="form-control"
                              v-model="dislike"
                            ></v-chip-input>-->

                            <div class="col-md-10">
                              <div class="form-group">
                                <input
                                  placeholder="Add Dislikes"
                                  ref="dislike"
                                  name="dislike"
                                  data-vv-as="dislike"
                                  class="form-control"
                                  v-model="dislike"
                                  v-validate="'min:3|max:50'"
                                  v-bind:class="{
                                    'is-invalid': errors.has('dislike'),
                                  }"
                                />
                                <div class="invalid-feedback">{{ errors.first("dislike") }}</div>
                              </div>
                            </div>

                            <button
                              type="button"
                              class="btn btn-primary btn-sm"
                              @click="clickDislike()"
                            >Add +</button>

                            <!-- <a
                              class="icon-edit"
                              v-if="dislikeHover"
                              @click="updateWishlist({dislike:'dislike'})"
                            >
                              <i class="fa fa-save"></i> Save
                            </a>-->
                            <a class="icon-edit" @click="editingDislike = false">
                              <i class="fa fa-times"></i> Close
                            </a>

                            <!-- <v-chip-input
                            v-if="editingDislike"
                            input-class="form-control"
                            v-model="dislike"
                            ></v-chip-input>-->
                          </template>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card">
              <div class="card-header" id="headingTwo">
                <h5
                  class="mb-0 d-flex flex-wrap justify-content-between align-items-center"
                  v-bind:class="{ active: eventDetailActive }"
                  @click="clickEventDetail()"
                >
                  <button
                    class="btn btn-link"
                    data-toggle="collapse"
                    data-target="#collapseTwo"
                    aria-expanded="true"
                    aria-controls="collapseTwo"
                  >Event Details</button>
                </h5>
              </div>
              <div
                id="collapseTwo"
                class="collapse show"
                aria-labelledby="headingTwo"
                data-parent="#accordion"
              >
                <div class="card-body">
                  <div class="celeb-info event-details">
                    <span>Description</span>

                    <div class="more-info">
                      <p>
                        <!-- wishlist detail -->
                      </p>
                      <p @mouseover="detailHover = true" @mouseleave="detailHover = false">
                        <template v-if="!editingDetail">
                          {{ wishlistDetail.detail }}
                          <a
                            class="icon-edit"
                            v-if="detailHover && isHost && !isExpired"
                            @click="editingDetail = true"
                          >
                            <i class="fa fa-edit"></i> Edit
                          </a>
                        </template>
                        <template v-else>
                          <div class="form-group">
                            <textarea v-model="wishlistDetail.detail" class="form-control"></textarea>
                          </div>
                          <a
                            class="icon-edit"
                            @click="
                              updateWishlist({ detail: wishlistDetail.detail })
                            "
                          >
                            <i class="fa fa-save"></i>
                            {{ saveText }}
                          </a>
                          <a class="icon-edit" @click="editingDetail = false">
                            <i class="fa fa-times"></i> Close
                          </a>
                        </template>
                      </p>
                      <p>
                        <span>Unique Code</span>
                        <strong>{{ wishlistDetail.uniqueCode }}</strong>
                      </p>
                      <!-- wishlist date -->
                      <p @mouseover="dateHover = true" @mouseleave="dateHover = false">
                        <span>Date</span>

                        <template v-if="!editingDate">
                          <b class="detail-item">
                            {{
                            new Date(wishlistDetail.date).toString()
                            | moment("Do MMM YYYY")
                            }}
                          </b>
                          <a
                            class="icon-edit"
                            v-if="dateHover && isHost && !isExpired"
                            @click="editingDate = true"
                          >
                            <i class="fa fa-edit"></i> Edit
                          </a>
                        </template>
                        <template v-else>
                          <div class="form-group">
                            <datetime
                              class="theme-red"
                              input-id="date"
                              input-class="form-control"
                              v-model="wishlistDetail.date"
                              :min-datetime="minDatetime"
                            ></datetime>
                          </div>
                          <a
                            class="icon-edit"
                            @click="
                              updateWishlist({ date: wishlistDetail.date })
                            "
                          >
                            <i class="fa fa-save"></i> Save
                          </a>
                          <a class="icon-edit" @click="editingDate = false">
                            <i class="fa fa-times"></i> Close
                          </a>
                        </template>
                      </p>
                      <!-- wishlist time -->
                      <p @mouseover="timeHover = true" @mouseleave="timeHover = false">
                        <span>Time</span>
                        <template v-if="!editingTime">
                          {{ new Date(time).toString() | moment("hh:mm A") }}
                          <a
                            class="icon-edit"
                            v-if="timeHover && isHost && !isExpired"
                            @click="editingTime = true"
                          >
                            <i class="fa fa-edit"></i> Edit
                          </a>
                        </template>
                        <template v-else>
                          <div class="form-group">
                            <datetime
                              class="theme-red"
                              input-class="form-control"
                              input-id="time"
                              type="time"
                              v-model="time"
                              :min-datetime="minDatetime"
                              use12-hour
                            ></datetime>
                          </div>
                          <a class="icon-edit" @click="updateWishlist({ time: time })">
                            <i class="fa fa-save"></i> Save
                          </a>
                          <a class="icon-edit" @click="editingTime = false">
                            <i class="fa fa-times"></i> Close
                          </a>
                        </template>
                      </p>
                      <p @mouseover="locationHover = true" @mouseleave="locationHover = false">
                        <span>Location</span>
                        <template v-if="!editingLocation">
                          {{ wishlistDetail.location.address }}
                          <a
                            class="icon-edit"
                            v-if="locationHover && isHost && !isExpired"
                            @click="editingLocation = true"
                          >
                            <i class="fa fa-edit"></i> Edit
                          </a>
                        </template>
                        <template v-else>
                          <div class="form-group">
                            <input class="form-control" v-model="wishlistDetail.location.address" />
                          </div>
                          <a
                            class="icon-edit"
                            @click="
                              updateWishlist({
                                'location.address':
                                  wishlistDetail.location.address,
                              })
                            "
                          >
                            <i class="fa fa-save"></i> Save
                          </a>
                          <a class="icon-edit" @click="editingLocation = false">
                            <i class="fa fa-times"></i> Close
                          </a>
                        </template>
                      </p>
                    </div>
                    <div class="guest">
                      <div class="title-view d-flex flex-wrap">
                        <h5 v-if="filteredParticipants.length > 0">Guest List</h5>
                        <a
                          v-if="filteredParticipants.length > 0"
                          href="#"
                          data-toggle="modal"
                          data-target="#guestListModal"
                        >View all</a>
                        <ul class="list-guest">
                          <li
                            :key="participant._id"
                            v-for="(participant, index) in filteredParticipants"
                            class="indv-guest"
                          >
                            <img
                              v-if="participant.profileImage"
                              :src="participant.profileImage"
                              :alt="participant.name"
                              :title="participant.name"
                            />
                            <img
                              v-else
                              src="../../public/assets/images/participant.png"
                              :alt="participant.name"
                              :title="participant.name"
                            />
                          </li>

                          <li v-if="extraParticipantsCount != null" class="indv-guest guest-all">
                            <a
                              data-toggle="modal"
                              data-target="#guestListModal"
                              class="all-view"
                            >+{{ extraParticipantsCount }}</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="spinner">
          <div
            class="spinner-border dashboard-spinner"
            style="width: 3rem; height: 3rem;color:#FD3E75;"
            role="status"
          ></div>
        </div>
      </div>
    </div>

    <!-- MODAL GUEST LIST -->
    <div
      class="modal fade more-guest-list"
      id="guestListModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="guestListModal"
      aria-hidden="true"
      @close="closeGuestModal()"
    >
      <div class="modal-dialog model-lg" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <h3>Guest list</h3>
            <img
              class="close"
              src="../../public/assets/images/close.svg"
              data-dismiss="modal"
              aria-label="Close"
            />
            <ul class="list-guest">
              <li
                :key="participant._id"
                v-for="participant in wishlistDetail.participants"
                class="indv-guest"
              >
                <div class="img-wrap">
                  <img
                    v-if="participant.profileImage"
                    :src="participant.profileImage"
                    :alt="participant.name"
                    :title="participant.name"
                  />
                  <img
                    v-else
                    src="../../public/assets/images/participant.png"
                    :alt="participant.name"
                    :title="participant.name"
                  />
                </div>
                <p>{{ participant.name }}</p>
                <p class="delete-icon" v-if="isHost && !isExpired">
                  <img
                    src="../../public/assets/images/delete.png"
                    alt="delete icon"
                    data-toggle="modal"
                    href="#confirmationModal"
                    @click="openConfirmationModal(participant)"
                  />
                  <!-- @click="deleteGuest(participant._id)" -->
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- MODAL Croppie -->
    <div
      class="modal more-guest-list"
      id="cropImageModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="cropImageModal"
      aria-hidden="true"
      :show="initialiseCropper()"
      ref="cropImageModal"
    >
      <div class="modal-dialog model-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h3 class="modal-title">Crop Image</h3>
            <img
              class="close"
              src="../../public/assets/images/close.svg"
              data-dismiss="modal"
              aria-label="Close"
              @click="closeCropperModal()"
            />
          </div>
          <div class="modal-body">
            <div
              v-if="showSpinner === true"
              class="spinner-border"
              style="width: 3rem; height: 3rem;color:#FD3E75;"
              role="status"
            ></div>
            <vue-croppie
              v-if="showSpinner === false"
              ref="croppieRef"
              :enableOrientation="true"
              :enforceBoundary="true"
              :enableResize="false"
              @result="result"
              @update="update"
              :mouseWheelZoom="false"
              :showZoomer="true"
              :viewport="{ width: 322, height: 215, type: 'square' }"
              :boundry="{ width: 600, height: 430}"
            ></vue-croppie>
          </div>
          <div class="modal-footer">
            <button
              v-if="imagePreview && !cropped"
              class="btn btn-primary crop-button"
              @click="crop()"
            >
              <i class="fa fa-crop"></i> Crop
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL STARTS -->
    <div
      class="modal fade more-guest-list"
      id="confirmationModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="confirmationModal"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5>Uninvite guest</h5>
            <img
              class="close"
              src="../../public/assets/images/close.svg"
              data-dismiss="modal"
              aria-label="Close"
            />
          </div>
          <div class="modal-body">
            <div class="alert alert-danger alert-dismissible" role="alert" v-if="showAlertMessage">
              {{ apiErrorMessage }}
              <img
                class="close"
                src="../../public/assets/images/close.svg"
                data-dismiss="alert"
                aria-label="close"
                @click="showAlertMessage = !showAlertMessage"
              />
            </div>

            <div
              class="alert alert-success alert-dismissible"
              role="alert"
              v-if="showSuccessAlertMessage"
            >
              {{ apiSuccessMessage }}
              <img
                class="close"
                src="../../public/assets/images/close.svg"
                data-dismiss="alert"
                aria-label="close"
                @click="showSuccessAlertMessage = !showSuccessAlertMessage"
              />
            </div>
            <h4>Do you want to uninvite {{ uninvitedGuest.name }}?</h4>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
            <button
              type="button"
              class="btn btn-primary"
              @click="deleteGuest(uninvitedGuest._id)"
            >Yes</button>
          </div>
        </div>
      </div>
    </div>
    <!-- MODAL ENDS -->
  </div>
</template>
<style>
@import "../../public/assets/css/lightbox.css";
</style>
<script>
import Vue from "vue";
import { Vuex, mapState } from "vuex";
import "../plugins/fb-sdk.js";
import {
  GET_WISHLIST_DETAIL,
  UPLOAD_WISHLIST_IMAGE,
  CHECK_PARTICIPANT,
  UPDATE_WISHLIST,
  DELETE_GUEST,
  // SET_EDITED_WISHLIST
} from "../store/wishlist/action.type";
import AddGift from "../components/gift/AddGift";
import VChip from "v-chip";
import VChipInput from "v-chip/src/v-chip-input.js";
import ListGift from "../components/gift/ListGift";
import VueCroppie from "vue-croppie";
// import { Validator } from "vee-validate";
import "croppie/croppie.css"; // import the croppie css manually
export default {
  name: "wishlistDetail",
  components: {
    "add-gift": AddGift,
    "list-gift": ListGift,
  },
  data() {
    return {
      editingWishlistName: false,
      editingCelebrantName: false,
      wishlistNameHover: false,
      celebrantNameHover: false,
      editingLikes: false,
      editingDislike: false,
      likesHover: false,
      dislikeHover: false,
      editingDate: false,
      dateHover: false,
      editingTime: false,
      timeHover: false,
      editingDetail: false,
      detailHover: false,
      editingLocation: false,
      locationHover: false,
      hover: false,
      like: null,
      dislike: null,
      likes: [],
      dislikes: [],
      options: [1, 2, 3],
      time: null,
      wishlistDetail: {
        user: {},
        likes: [],
        dislike: [],
        location: [],
        participants: [],
        date: "",
      },
      saveText: "Save",
      calculatedDate: null,
      celebrantActive: true,
      eventDetailActive: true,
      minDatetime: new Date().toISOString(),
      showAddGiftModal: false,

      //for croppie
      cropped: null,
      // loaded: null, //for old
      loaded: "../assets/images/detail.png",
      file: "",
      showPreview: false,
      // imagePreview: null,
      imagePreview: "../assets/images/detail.png",
      imageHover: null,
      showSpinner: false,

      isHost: false,
      timeDifference: "",
      one_day: 1000 * 60 * 60 * 24, //one day in milliseconds

      isExpired: false,
      celebrantName: "",

      showAlertMessage: false,
      showSuccessAlertMessage: false,

      //sort gift
      want: "Desire",
      purchased: "All",
      uninvitedGuest: "",
    };
  },
  computed: {
    filteredParticipants() {
      return this.wishlistDetail.participants.slice(0, 5);
    },
    extraParticipantsCount() {
      let totalParticipants = this.wishlistDetail.participants.length - 5;
      if (totalParticipants > 0) return totalParticipants;
    },
    ...mapState({
      // map this.count to store.state.count
      currentUser: (state) => state.auth.userDetails._id,
    }),
    // date() {
    //   console.log("changed");
    //   let utcHours = new Date(this.time).getHours();
    //   let utcMinutes = new Date(this.time).getMinutes();

    //   let utcDate = new Date(this.date);

    //   utcDate.setHours(utcHours);
    //   utcDate.setMinutes(utcMinutes);
    //   console.log(utcDate);

    //   if (utcDate) {
    //     return new Date(utcDate);
    //   }
    // }
  },
  watch: {
    wishlistDetail: {
      handler: function (newValue, oldValue) {
        let utcHours = new Date(this.time).getHours();
        let utcMinutes = new Date(this.time).getMinutes();

        let utcDate = new Date(newValue.date);

        utcDate.setHours(utcHours);
        utcDate.setMinutes(utcMinutes);

        if (utcDate) {
          this.calculatedDate = new Date(utcDate);
        }
      },
      deep: true,
    },
    time: {
      handler: function (newValue, oldValue) {
        let utcHours = new Date(newValue).getHours();
        let utcMinutes = new Date(newValue).getMinutes();

        let utcDate = new Date(this.wishlistDetail.date);

        utcDate.setHours(utcHours);
        utcDate.setMinutes(utcMinutes);

        if (utcDate) {
          this.calculatedDate = new Date(utcDate);
        }
      },
    },
    timeDifference(data) {
      if (data) {
        var self = this;
        self.timeDifference =
          (new Date(this.time).getTime() - new Date().getTime()) / this.one_day;
      }
    },
  },
  beforeCreate() {
    // console.log("before create");
    if (this.$route.query.hostId) {
      localStorage.sharedEvent = JSON.stringify(this.$route.query);
      localStorage.sharedEventId = this.$route.params.id;
    }
    this.sharedEvent = JSON.parse(localStorage.getItem("sharedEvent"));
    this.sharedEventId = localStorage.getItem("sharedEventId");
    this.user = JSON.parse(localStorage.getItem("user"));
    if (this.sharedEventId) {
      if (this.sharedEvent.hostId != this.user._id) {
        this.$store
          .dispatch(CHECK_PARTICIPANT, this.sharedEventId)
          .then((response) => {
            if (!response.data.data.status) {
              return this.$router.push({ path: "/acceptReject" });
            }
          });
      }
    }
  },
  created() {
    //define default functions
    window.removeLikes = this.removeLikes;
    window.removeDislikes = this.removeDislikes;
  },
  mounted() {
    //get details
    this.$store
      .dispatch(GET_WISHLIST_DETAIL, this.$route.params.id)
      .then((response) => {
        console.log("Response", response);
        this.wishlistDetail = response.data.data;
        this.time = this.wishlistDetail.date;
        // console.log("calculated likes");
        // console.log(this.wishlistDetail.likes);

        //set likes and dislikes
        for (let like of this.wishlistDetail.likes) {
          this.likes.push(like.item);
        }
        for (let dis of this.wishlistDetail.dislike) {
          this.dislikes.push(dis.item);
        }

        //check if host
        if (
          this.currentUser == this.wishlistDetail.user._id &&
          this.wishlistDetail.archived == false
        ) {
          this.isHost = true;
        }
        // console.log(this.wishlistDetail);

        this.timeDifference =
          (new Date(this.time).getTime() - new Date().getTime()) / this.one_day; //get the difference of current time and event time

        this.celebrantName = this.wishlistDetail.celebrantInformation;
        //check if wishlist has expired
        if (this.wishlistDetail.archived == false && this.timeDifference > 0) {
          this.isExpired = false;
        } else {
          this.isExpired = true;
        }
        console.log("WD", this.wishlistDetail);
      })
      .catch((error) => {
        console.log(error);
      });

    // ACCORDION TITLE ACTIVE CLASS ADDED AND REMOVED
    $(".card-header h5").on("click", function () {
      $(this).toggleClass("active");
    });
  },
  methods: {
    arrayToObject(array) {
      let object = [];
      for (let a of array) {
        object.push({ item: a });
      }
      return object;
    },
    // shareToFacebook(){
    //   this.isFBReady = Vue.FB != undefined
    //   window.addEventListener('fb-sdk-ready', this.onFBReady)
    // },
    shareToFacebook() {
      Vue.FB.ui({
        method: "send",
        link: this.wishlistDetail.dynamicLink,
        redirect_uri: window.location.href,
      });
    },

    openAddGiftModal() {
      this.showAddGiftModal = true;
    },

    closeAddGiftModal() {
      this.showAddGiftModal = false;
    },

    imgHover() {
      this.imageHover = true;
    },
    imgHoverLeave() {
      this.imageHover = null;
    },
    initialiseCropper() {
      // console.log("shown");
      // console.log(this.imagePreview);
      if (this.$refs.croppieRef) {
        this.$refs.croppieRef.bind({
          url: this.imagePreview,
          zoom: 0.2,
        });

        // this.refresh();
        // this.initCroppie();
      }
    },
    uploadImage() {
      // upload cropped image
      const uploadBody = {
        image: this.cropped,
      };

      if (this.cropped) {
        this.$store
          .dispatch(UPLOAD_WISHLIST_IMAGE, uploadBody)
          .then((response) => {
            if (response.status == 200) {
              // console.log(response.data.data.file);
              // this.apiSuccessMessage = response.data.message;
              // this.apiErrorMessage = null;
              this.image = response.data.data.file;
              this.wishlistDetail.image = response.data.data.file;

              this.updateWishlist({ image: this.image });
            } else {
              this.showSpinner = null;
              this.disabled = null;
              this.buttonText = "Create Event";
              this.apiErrorMessage = response.data.message;
              this.apiSuccessMessage = null;
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },

    /*
    Handles update wishlist
  */
    updateWishlist(body) {
      this.saveText = "Saving..";
      if (body.date || body.time) {
        body.date = this.calculatedDate;
      }
      if (body.likes) {
        body.likes = this.arrayToObject(this.likes);
      }
      if (body.dislike) {
        body.dislike = this.arrayToObject(this.dislikes);
      }
      // console.log(body);
      // process.exit();
      let payload = { id: this.wishlistDetail._id, data: body };
      /* save other data after image upload */
      this.$store
        .dispatch(UPDATE_WISHLIST, payload)
        .then((response) => {
          if (response.status == 200) {
            console.log('edit response',response);
            //for image upload
            this.showSpinner = false;
            
            this.apiSuccessMessage = response.data.message;
            this.apiErrorMessage = null;
            if (body.detail) {
              this.editingDetail = false;
            }
            if (body.name) {
              this.editingWishlistName = false;
            }
            if (body.date) {
              this.editingDate = false;
            }
            if (body.time) {
              this.editingTime = false;
            }
            if (body.date) {
              this.editingDate = false;
            }

            if ("location.address" in body) {
              this.editingLocation = false;
            }

            
            $("#cropImageModal").modal("hide");
            this.refresh();
            this.initCroppie();
            this.$refs.croppieRef.bind({ url: "" });

            if (body.name) {
              this.editingWishlistName = false;
            }
            if (body.celebrantInformation) {
              this.editingCelebrantName = false;
            }

            
          } else {
            this.apiErrorMessage = response.data.message;
            this.apiSuccessMessage = null;
          }
          //reset params
          this.showSpinner = false;
          this.disabled = null;
          this.saveText = "Save";
        })
        .catch((error) => {
          // this.apiErrorMessage = error.response.data.message;
          this.apiSuccessMessage = null;
          //reset params
          this.showSpinner = false;
          this.disabled = null;
          this.saveText = "Save";
        });
    },
    handleFileUpload() {
      let self = this;
      this.cropped = null;
      /*
      Set the local file variable to what the user has selected.
    */
      this.file = this.$refs.file.files[0];

      /*
      Initialize a File Reader object
    */
      let reader = new FileReader();

      /*
      Add an event listener to the reader that when the file
      has been loaded, we flag the show preview as true and set the
      image to be what was read from the reader.
    */
      reader.addEventListener(
        "load",
        function () {
          self.showPreview = true;

          self.imagePreview = reader.result;
          // alert(this.imagePreview);
          self.$refs.file.value = "";
          if (self.imagePreview) {
            $("#cropImageModal").on("shown.bs.modal", function () {
              // alert("initailised");

              self.refresh();
              self.initCroppie();
              self.$refs.croppieRef.bind({
                url: self.imagePreview,
                zoom: 0.2,
              });
              // alert("initailised complete");
            });
            // alert("modalLoaded");
            $("#cropImageModal").modal("show");
          }

          //   .then(function() {
          //     $("#cropImageModal").modal("show");
          //   });
        }.bind(this),
        false
      );

      /*
      Check to see if the file is not empty.
    */
      if (this.file) {
        /*
        Ensure the file is an image file.
      */
        if (/\.(jpe?g|png|gif)$/i.test(this.file.name)) {
          /*
          Fire the readAsDataURL method which will read the file in and
          upon completion fire a 'load' event which we will listen to and
          display the image in the preview.
        */
          reader.readAsDataURL(this.file);
        }
      }
    },
    //settings for croppie
    // bind() {
    //   // Randomize cat photos, nothing special here.
    //   let url = this.images[Math.floor(Math.random() * 4)];

    //   // Just like what we did with .bind({...}) on
    //   // the mounted() function above.
    //   this.$refs.croppieRef.bind({
    //     url: url
    //   });
    // },
    // CALBACK USAGE
    crop() {
      // Here we are getting the result via callback function
      // and set the result to this.cropped which is being
      // used to display the result above.
      let options = {
        format: "jpeg",
        circle: false,
        size: { width: 1028 },
      };
      this.$refs.croppieRef.result(options, (output) => {
        this.cropped = output;

        //upload image
        this.showSpinner = true;
        this.uploadImage();
      });
    },
    // EVENT USAGE
    cropViaEvent() {
      this.$refs.croppieRef.result(options);
    },
    result(output) {
      this.cropped = output;
    },
    update(val) {
      // console.log(val);
    },
    rotate(rotationAngle) {
      // Rotates the image
      this.$refs.croppieRef.rotate(rotationAngle);
    },
    refresh() {
      this.$refs.croppieRef.destroy();
    },
    initCroppie() {
      this.$refs.croppieRef.initCroppie();
    },
    clickLike() {
      this.$validator.validateAll().then((success) => {
        // submit the value

        if (this.like && $.inArray(this.like, this.likes) == -1 && success) {
          let display = "'none'";
          let appendChips =
            '<div><div index="0" class="chip" style="color: rgb(51, 51, 51); background-color: rgb(241, 241, 241);"><span class="chip-item">';
          appendChips += this.like;
          appendChips +=
            '</span><span onclick="removeLikes(this)" class="closebtn">×</span></div></div>';
          $(".likes .addmore").prepend(appendChips);

          this.likes.push(this.like);

          //update api
          this.updateWishlist({ likes: "like" });

          this.like = null;
          if (this.$refs.like) {
            this.$refs.like.focus();
          }
        }
      });
    },

    removeLikes($this) {
      //remove from array
      var index = this.likes.indexOf($($this).prev(".chip-item").text());
      if (index !== -1) {
        this.likes.splice(index, 1);
      }
      //update api
      this.updateWishlist({ likes: "like" });
      $($this).parent().remove();
      if (this.$refs.like) {
        this.$refs.like.focus();
      }
    },
    //add dislikes
    clickDislike() {
      this.$validator.validateAll().then((success) => {
        if (
          this.dislike &&
          $.inArray(this.dislike, this.dislikes) == -1 &&
          success
        ) {
          let display = "'none'";
          let appendChips =
            '<div><div index="0" class="chip" style="color: rgb(51, 51, 51); background-color: rgb(241, 241, 241);"><span class="chip-item">';
          appendChips += this.dislike;
          appendChips +=
            '</span><span onclick="removeDislikes(this)" class="closebtn">×</span></div></div>';
          $(".dislike .addmore").prepend(appendChips);

          this.dislikes.push(this.dislike);

          //update api
          this.updateWishlist({ dislike: "dislike" });
          this.dislike = null;
          if (this.$refs.dislike) {
            this.$refs.dislike.focus();
          }
        }
      });
    },

    removeDislikes($this) {
      //remove from array
      var index = this.dislikes.indexOf($($this).prev(".chip-item").text());
      if (index !== -1) {
        this.dislikes.splice(index, 1);
      }
      //update api
      this.updateWishlist({ dislike: "dislike" });
      $($this).parent().remove();
      if (this.$refs.dislike) {
        this.$refs.dislike.focus();
      }
    },
    clickCelebrant() {
      this.celebrantActive = !this.celebrantActive;
    },
    clickEventDetail() {
      this.eventDetailActive = !this.eventDetailActive;
    },
    closeCropperModal() {
      this.imagePreview = null;
    },

    deleteGuest(participantId) {
      let body = {
        wishlistId: this.wishlistDetail._id,
        participantId: participantId,
      };
      this.$store
        .dispatch(DELETE_GUEST, body)
        .then((response) => {
          if (response.status != 200) {
            this.apiErrorMessage = response.data.message;
            this.showAlertMessage = true;
          } else {
            this.wishlistDetail.participants = response.data.data.participants;
            this.apiSuccessMessage = response.data.message;
            this.showSuccessAlertMessage = true;
            setTimeout(() => {
              this.closeConfirmationModal();
            }, 500);
          }
        })
        .catch((error) => {
          console.log("Error", error);
          this.apiErrorMessage = error.response.data.message;
          this.showAlertMessage = true;
        });
    },

    closeConfirmationModal() {
      $("#confirmationModal").modal("hide");
      this.apiSuccessMessage = null;
      this.showSuccessAlertMessage = false;
    },

    openConfirmationModal(uninvitedGuest) {
      this.uninvitedGuest = uninvitedGuest;
      $("#confirmationModal").modal("show");
    },
  },
};
</script>
<style>
#confirmationModal .modal-body{
  padding: 35px 35px 35px 10px;
}
#cropImageModal .spinner-border {
  position: absolute;
  top: 50%;
  left: 45%;
  margin: 0;
}
.icon-edit {
  display: inline-block;
  margin-top: 10px;
}
.chip {
  color: rgb(51, 51, 51);
  background-color: rgb(241, 241, 241);
}
.lb-dataContainer .lb-data .lb-close::before {
  content: "" !important;
}
.chip-item {
  font-size: 1rem !important;
}
#collapseOne .closebtn {
  line-height: 2 !important;
}
.addmore a {
  padding-top: 5px;
}
.addmore .col-md-10 {
  /* padding-left: 0px !important; */
}
.addmore input {
  padding: 10px;
}
.delete-icon {
  float: right;
  padding: 15px 0px;
}
.sort-gift {
  padding-top: 20px;
  height: 50%;
  color: #6d589b;
}
.select-sort {
  /* border: 0.0625rem solid #fd3e75; */
  border: none;
  color: #6d589b;
  height: 100%;
  /* float: right; */
}

#confirmationModal {
  background: rgba(0, 0, 0, 0.5);
}
</style>
